import { render, staticRenderFns } from "./OUserAddForm.vue?vue&type=template&id=2fa03e98"
import script from "./OUserAddForm.vue?vue&type=script&lang=js"
export * from "./OUserAddForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports